import {ChangeEvent, FC, useCallback, useEffect, useMemo} from 'react';
import {useField} from 'formik';
import {useTranslation} from 'react-i18next';
import RangeInput from '../../../../../../common/formik/inputs/RangeInput';
import {PERCENT_RATE} from '../../../../../../../constants/timeProgressBar';
import {EmployeeSatisfactionStatuses} from '../../../../../types';
import {getEmployeeSatisfactionIcon} from '../helpers/getEmployeeSatisfactionIcon';

type SentimentSliderProps = {
  name: string,
  disabled: boolean,
  satisfactionStatuses: EmployeeSatisfactionStatuses[]
}

const SentimentSlider: FC<SentimentSliderProps> = ({
  name,
  satisfactionStatuses = [],
  disabled
}) => {
  const {t} = useTranslation('tasks');
  const [{value}, , {setValue, setTouched}] = useField(name);

  const minValue = 0;
  const maxValue = satisfactionStatuses?.length - 1;
  const initialValue = satisfactionStatuses.findIndex(
      (elem) => elem.code === value);

  const onChange = useCallback( (event: ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
    setTouched(true);
  }, []);

  useEffect(() => {
    if (initialValue !== -1) {
      setValue(initialValue.toString());
    }
  }, []);

  const smileIconPosition = useMemo(() => {
    let valueInPercent = ((value - minValue) * PERCENT_RATE) /
    (maxValue - minValue);

    if (valueInPercent === PERCENT_RATE) {
      valueInPercent -= 1;
    } else if (valueInPercent === minValue) {
      valueInPercent += 1;
    }

    return valueInPercent;
  }, [value]);

  const SmileIcon = useMemo(() => getEmployeeSatisfactionIcon(value), [value]);

  return (
    <>
      <h5 className="questionnaire__subtitle">
        {t('employeeSurvey.questionnaire.sentimentSlider.title')}
      </h5>

      <p className="questionnaire__text">
        {t('employeeSurvey.questionnaire.sentimentSlider.text')}
      </p>

      <div className="sentiment-slider">
        <div className="sentiment-slider__smile" style={{left: `${smileIconPosition}%`}}>
          {SmileIcon}
        </div>
        <RangeInput name="range" max={maxValue} min={minValue} onChange={onChange} value={value} disabled={disabled} />
      </div>
    </>
  );
};

export default SentimentSlider;
